import { render } from "./LoginBtn.vue?vue&type=template&id=fde14072"
import script from "./LoginBtn.vue?vue&type=script&lang=js"
export * from "./LoginBtn.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__